import React from 'react';
import PropTypes from 'prop-types';
import StepItem from './StepItem';

const Stepper = ({ currentStep }) => {
  const steps = [
    { number: 1, label: 'Basic Info' },
    { number: 2, label: 'Contact & Location' },
    { number: 3, label: 'Services & Hours' },
    { number: 4, label: 'Media & Social' }
  ];

  return (
    <div className="stepper">
      {steps.map((step, index) => (
        <StepItem
          key={step.number}
          number={step.number}
          label={step.label}
          isActive={currentStep === step.number}
          isCompleted={currentStep > step.number}
          isLast={index === steps.length - 1}
        />
      ))}
    </div>
  );
};

Stepper.propTypes = {
  currentStep: PropTypes.number.isRequired
};

export default Stepper;
